import { render, staticRenderFns } from "./ClaudiaCompanionWidgetMicrofrontend.vue?vue&type=template&id=2abf3575"
import script from "./ClaudiaCompanionWidgetMicrofrontend.vue?vue&type=script&lang=js"
export * from "./ClaudiaCompanionWidgetMicrofrontend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports